import React from 'react';
import BooleanStep from './BooleanStep';

export default class AltPayGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'AltPay' }
      />
    );
  }
}
